export default __webpack_public_path__ + "static/media/Capture.611de11d.png";